import {
  BookStudyUnitName,
  CreatingResilientAusClassroomsId,
  CreatingResilientClassroomsId,
  lessonTypeOptionsWithNone,
} from "@constants";
import { MIXPANEL_LESSON_TYPE } from "@src/constants/analyticsTracking";
import { SllLesson } from "@api/graphql-codegen";

type StandaloneLessonTypeArgs = {
  lesson: Pick<SllLesson, "uniqueName" | "lessonType">;
  programName?: string | undefined;
};

type UnitLessonTypeArgs = {
  unitName?: string | undefined | null;
  unitId?: string | undefined | null;
  unitUniqueName?: string | undefined | null;
};

const STANDALONE_LESSON_TYPE_BY_LABEL: Record<string, string> = {
  None: MIXPANEL_LESSON_TYPE.NONE,
  "Student Voice": MIXPANEL_LESSON_TYPE.STUDENT_VOICE,
  "Positive Pathways": MIXPANEL_LESSON_TYPE.POSITIVE_PATHWAYS,
  "Brain Break": MIXPANEL_LESSON_TYPE.BRAIN_BREAK,
  "Skill-Builder": MIXPANEL_LESSON_TYPE.SKILL_BUILDER,
  "Educator Content": MIXPANEL_LESSON_TYPE.EDUCATOR_CONTENT,
  Resource: MIXPANEL_LESSON_TYPE.RESOURCE,
  Caregiver: MIXPANEL_LESSON_TYPE.CAREGIVER,
  "Student Introduction": MIXPANEL_LESSON_TYPE.STUDENT_INTRODUCTION,
  StudentIntroduction: MIXPANEL_LESSON_TYPE.STUDENT_INTRODUCTION,
};

export function resolveStandaloneMixpanelLessonType({
  lesson,
}: StandaloneLessonTypeArgs): string | undefined {
  const uniqueName = (lesson.uniqueName || "").toLowerCase();
  const isPrePostProgramQuiz =
    uniqueName.includes("preprogram-quiz") || uniqueName.includes("postprogram-quiz");
  if (isPrePostProgramQuiz) return MIXPANEL_LESSON_TYPE.QUIZ;

  const label = lessonTypeOptionsWithNone.find(
    (opt) => opt.value === lesson.lessonType,
  )?.label;

  return label ? STANDALONE_LESSON_TYPE_BY_LABEL[label] : undefined;
}

export function resolveUnitMixpanelLessonType({
  unitName,
  unitId,
  unitUniqueName,
}: UnitLessonTypeArgs): string {
  if (unitName === "Pre-Program Quiz" || unitName === "Post-Program Quiz") {
    return MIXPANEL_LESSON_TYPE.QUIZ;
  }

  if (unitName === "Educator Onboarding") {
    return MIXPANEL_LESSON_TYPE.ONBOARDING;
  }

  if (unitName === "Educator Wellbeing") {
    return MIXPANEL_LESSON_TYPE.EDUCATOR_CONTENT;
  }

  if (unitUniqueName === BookStudyUnitName) {
    return MIXPANEL_LESSON_TYPE.EDUCATOR_CONTENT;
  }

  if (
    unitId === CreatingResilientClassroomsId ||
    unitId === CreatingResilientAusClassroomsId
  ) {
    return MIXPANEL_LESSON_TYPE.EDUCATOR_CONTENT;
  }

  return "";
}

